module.exports = "img {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/image-previwer/image-preview.scss
// module id = ./src/app/shared/components/image-previwer/image-preview.scss
// module chunks = main